import { defineStore } from 'pinia';

export const useMobileMenuStore = defineStore(
    'mobileMenu',
    {
        state: () => ({
            isSearchVisible: false,
        }),
        actions: {
            toggleSearch() {
                this.isSearchVisible = !this.isSearchVisible;
            },
        },
    });
